import { Box, styled } from '@mui/joy'

export const LocaleWrapper = styled(Box)`
  position: absolute;
  top: -3px;
  right: 0;
  width: 140px;
`
